import { isUSPSTokenExpired } from './isUSPSTokenExpired';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase.config';

export const fetchValidUSPSToken = async () => {
    if (isUSPSTokenExpired()) {
        
        const getAccessToken = httpsCallable(functions, 'getAccessToken');
        const response = await getAccessToken();
        
        const newToken = response.data?.accessToken;

        if (newToken) {
            const expiresAt = Date.now() + 8 * 60 * 60 * 1000; // 8 hours
            localStorage.setItem('uspsAccessToken', newToken);
            localStorage.setItem('uspsTokenExpiry', expiresAt.toString());
            return newToken;
        } else {
            throw new Error('Unable to fetch new USPS access token.');
        }
    } else {
        console.log('Token expiry time:', localStorage.getItem('uspsTokenExpiry'));
        return localStorage.getItem('uspsAccessToken');
    }
};
